module.exports = __webpack_public_path__ + "static/media/4000.2376d1f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/4000.mp3
// module id = gw8a
// module chunks = 1